import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import RegulatoryPartners from '../components/RegulatoryPartners';
import HowItWorks from '../components/HowItWorks';
import WhyWorkWithUs from '../components/WhyWorkWithUs';
import FraudTypes from '../components/FraudTypes';
import BitcoinChart from '../components/BitcoinChart';
import TeamSection from '../components/TeamSection';
import AboutSection from '../components/AboutSection';
import Footer from '../components/Footer';
import '../HomeRefresh.css';

const HomePage = () => {
  return (
    <div className="tb-home">
      <Header />
      <main>
        <HeroSection />
        <RegulatoryPartners />
        <FraudTypes />
        <BitcoinChart />
        <HowItWorks />
        <WhyWorkWithUs />
        <TeamSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
